import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { AspectRatio } from 'components/AspectRatio'
import { Button } from 'components/button/Button'
import MemoryTitle from 'components/content/memory/memoryTitle/MemoryTitle'
import { OrangeTag } from 'components/Tag'
import { Text } from 'components/Typography'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SMemoryToolBar = styled.div`
  display: flex;
  height: ${pxToRem(75)}rem;
  align-items: center;
  width: 100%;
  flex-direction: row-reverse;
  justify-content: space-between;
  & text {
    display: none;
  }
`

export const STools = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  margin-left: ${pxToRem(24)}rem;
  @media ${BREAKPOINTS.MD.max} {
    margin-right: 1rem;
  }
`

export const SIconButton = styled(Button)`
  color: white;
  margin-right: ${pxToRem(24)}rem;
  @media ${BREAKPOINTS.MD.max} {
    margin-right: 1rem;
  }
  position: relative;
`

export const SAnimateContainer = styled.div<{ inDropdown: boolean }>`
  display: flex;
  align-items: center;

  ${({ inDropdown }) =>
    inDropdown &&
    css`
      flex-direction: column;

      align-items: flex-start;
      ${SIconButton} {
        color: var(--c-blue500);

        &:not(:first-child) {
          margin-top: 1rem;
        }
      }
    `}
`

export const SAnimationContainer = styled.div`
  display: flex;
`

export const SDisappearingButtonText = styled(Text)`
  color: white;
  font-weight: bold;
  @media ${BREAKPOINTS.LG.max} {
    display: none;
  }
`

export const SDropdownContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  right: 0;
  top: 100%;
  background-color: var(--c-white);
  border-radius: 2px;
  padding: ${pxToRem(16)}rem;
`

export const STitle = styled(MemoryTitle)`
  @media ${BREAKPOINTS.LG.max} {
    display: none;
  }
  margin: 0 auto;
  max-width: ${pxToRem(280)}rem;
`

export const SAnimateTip = styled.div`
  width: ${pxToRem(296)}rem;
`

export const SShareTip = styled.div`
  width: ${pxToRem(396)}rem;
  @media ${BREAKPOINTS.LG.max} {
    width: 70vw;
  }
`

export const STipTitle = styled(Text)`
  color: black;
  font-weight: bold;
`

export const SAnimateTipVideoContainer = styled(AspectRatio)`
  margin-bottom: 1rem;
  & > div {
    width: 100%;
  }
`

export const STag = styled(OrangeTag)`
  position: absolute;
  top: -1rem;
  right: -0.5rem;
  height: 1rem;
  width: 3rem;
`
